import { createSlice } from '@reduxjs/toolkit';
import { resetAdminPersistedJourneyState } from 'store/adminJourneyReset';

export interface PlanState {
  selectedPlan: string | null;
  validationStatus: string | null;
}

const initialState: PlanState = {
  selectedPlan: null,
  validationStatus: null,
};

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    setSelectedPlan(state, action: { payload: string | null }) {
      state.selectedPlan = action.payload;
    },
    setPlanValidationStatus(state, action: { payload: string | null }) {
      state.validationStatus = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetAdminPersistedJourneyState, () => ({ ...initialState }));
  },
});

export const { setSelectedPlan, setPlanValidationStatus } = planSlice.actions;
export default planSlice.reducer;
